module.exports = __webpack_public_path__ + "static/media/memberRemovedPopUp.6bc80285.png";